// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type OpenTopicEnrolmentQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  restartEnrolment?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
}>;


export type OpenTopicEnrolmentQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & TopicWithEnrolment_TopicModelAsEditor_Fragment
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & TopicWithEnrolment_TopicModelAsMember_Fragment
  )> }
);

export type OpenTopicEnrolmentThroughPathwayQueryVariables = PrivateSchemaTypes.Exact<{
  pathwayId: PrivateSchemaTypes.Scalars['PositiveInt'];
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  restartEnrolment?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
}>;


export type OpenTopicEnrolmentThroughPathwayQuery = (
  { __typename?: 'Query' }
  & { pathway?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'PathwayModelAsStudent' }
    & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'progress'>
    & { enrolmentOrSelfEnrol?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayEnrolmentModel' }
      & Pick<PrivateSchemaTypes.PathwayEnrolmentModel, 'progress'>
    )>, topic?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicModelAsMember' }
      & TopicWithEnrolment_TopicModelAsMember_Fragment
    )>, nextTopicAfter?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicModelAsMember' }
      & PathwayNextTopicFragment
    )> }
  )> }
);

export type OpenTopicWithVersionQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  topicVersion: PrivateSchemaTypes.Scalars['JSON'];
}>;


export type OpenTopicWithVersionQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & TopicWithVersion_TopicModelAsEditor_Fragment
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & TopicWithVersion_TopicModelAsMember_Fragment
  )> }
);

export type TopicDraftVersionQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type TopicDraftVersionQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'allow_comments' | 'workspace_id' | 'id'>
    & { workspace?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'WorkspaceModelAsCollaborator' }
      & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'role' | 'name'>
    )>, draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id' | 'created_at' | 'title' | 'summary' | 'pass_mark' | 'status' | 'minor_version' | 'allow_retry' | 'topic_type' | 'readDurationMins' | 'max_attempts' | 'number_quizzes'>
      & { elements: Array<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id' | 'data' | 'duration' | 'type' | 'updated_at'>
        & { documents: Array<(
          { __typename?: 'VideoDocument' }
          & Pick<PrivateSchemaTypes.VideoDocument, 'id' | 'status' | 'fileUrl' | 'cdnUrl' | 'mimeType'>
        )>, quizOptions: Array<(
          { __typename?: 'QuizOptionModelAsEditor' }
          & Pick<PrivateSchemaTypes.QuizOptionModelAsEditor, 'content' | 'id' | 'order' | 'feedback' | 'is_correct'>
        )> }
      )> }
    )>, author: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'email' | 'profile_img_url'>
    ) }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type UpdateEnrolmentProgressMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type UpdateEnrolmentProgressMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id'>
      & { updateProgress: (
        { __typename?: 'TopicEnrolmentModelAsStudent' }
        & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'progress' | 'completion_date' | 'max_visited_element'>
      ) }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id'>
      & { updateProgress: (
        { __typename?: 'TopicEnrolmentModelAsStudent' }
        & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'progress' | 'completion_date' | 'max_visited_element'>
      ) }
    )> }
  )> }
);

export type OpenedFromCampaignShareEmailMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  scheduledActionId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type OpenedFromCampaignShareEmailMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'openedFromCampaignShareEmail'>
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'openedFromCampaignShareEmail'>
  )> }
);

export type LastEnrolmentForUserQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type LastEnrolmentForUserQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'progress' | 'auto_correct' | 'completion_date' | 'max_visited_element' | 'isCpdEntry'>
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'progress' | 'auto_correct' | 'completion_date' | 'max_visited_element' | 'isCpdEntry'>
    )> }
  )> }
);

export type AddFreeQuizResponseMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  response: PrivateSchemaTypes.Scalars['String'];
}>;


export type AddFreeQuizResponseMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'completion_date'>
      & { addFreeQuizResponse?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ResponseModel' }
        & Pick<PrivateSchemaTypes.ResponseModel, 'is_correct' | 'freeQuizResponse' | 'topic_element_id'>
        & { optionResponses?: PrivateSchemaTypes.Maybe<Array<(
          { __typename?: 'SingleOptionResponse' }
          & Pick<PrivateSchemaTypes.SingleOptionResponse, 'value' | 'is_correct' | 'option_id'>
        )>> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'completion_date'>
      & { addFreeQuizResponse?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ResponseModel' }
        & Pick<PrivateSchemaTypes.ResponseModel, 'is_correct' | 'freeQuizResponse' | 'topic_element_id'>
        & { optionResponses?: PrivateSchemaTypes.Maybe<Array<(
          { __typename?: 'SingleOptionResponse' }
          & Pick<PrivateSchemaTypes.SingleOptionResponse, 'value' | 'is_correct' | 'option_id'>
        )>> }
      )> }
    )> }
  )> }
);

export type AddQuizResponseMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  optionResponses: Array<PrivateSchemaTypes.SingleOptionResponseInput> | PrivateSchemaTypes.SingleOptionResponseInput;
}>;


export type AddQuizResponseMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'completion_date'>
      & { addQuizResponse?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ResponseModel' }
        & Pick<PrivateSchemaTypes.ResponseModel, 'is_correct' | 'topic_element_id'>
        & { optionResponses?: PrivateSchemaTypes.Maybe<Array<(
          { __typename?: 'SingleOptionResponse' }
          & Pick<PrivateSchemaTypes.SingleOptionResponse, 'value' | 'is_correct' | 'option_id'>
        )>> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
    & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'completion_date'>
      & { addQuizResponse?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ResponseModel' }
        & Pick<PrivateSchemaTypes.ResponseModel, 'is_correct' | 'topic_element_id'>
        & { optionResponses?: PrivateSchemaTypes.Maybe<Array<(
          { __typename?: 'SingleOptionResponse' }
          & Pick<PrivateSchemaTypes.SingleOptionResponse, 'value' | 'is_correct' | 'option_id'>
        )>> }
      )> }
    )> }
  )> }
);

export type TopicWithVersion_TopicModelAsEditor_Fragment = (
  { __typename?: 'TopicModelAsEditor' }
  & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'allow_comments' | 'workspace_id' | 'deleted_at' | 'currentTitle' | 'lastPublishedDate' | 'firstPublishedDate'>
  & { topicVersions: Array<(
    { __typename?: 'TopicVersionModel' }
    & TopicVersionFragment
  )>, workspaceAsEditor?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'name'>
  )>, currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'allow_retry' | 'readDurationMins' | 'version' | 'max_attempts' | 'topic_type'>
  )>, lastCompletedEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'isCpdEntry'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'email' | 'profile_img_url'>
  ) }
);

export type TopicWithVersion_TopicModelAsMember_Fragment = (
  { __typename?: 'TopicModelAsMember' }
  & Pick<PrivateSchemaTypes.TopicModelAsMember, 'isWorkspaceAccessible' | 'id' | 'allow_comments' | 'workspace_id' | 'deleted_at' | 'currentTitle' | 'lastPublishedDate' | 'firstPublishedDate'>
  & { workspace: (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id' | 'name'>
  ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'allow_retry' | 'readDurationMins' | 'version' | 'max_attempts' | 'topic_type'>
  )>, lastCompletedEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'isCpdEntry'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'email' | 'profile_img_url'>
  ) }
);

export type TopicWithVersionFragment = TopicWithVersion_TopicModelAsEditor_Fragment | TopicWithVersion_TopicModelAsMember_Fragment;

export type TopicWithEnrolment_TopicModelAsEditor_Fragment = (
  { __typename?: 'TopicModelAsEditor' }
  & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'allow_comments' | 'workspace_id' | 'deleted_at' | 'currentTitle' | 'lastPublishedDate' | 'firstPublishedDate'>
  & { workspaceAsEditor?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'name'>
  )>, currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & CurrentTopicVersionFragment
  )>, enrolmentOrSelfEnrol: (
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'isCpdEntry' | 'id' | 'completion_date' | 'progress' | 'trackAccess' | 'attempt' | 'user_id' | 'topic_version_id' | 'auto_correct' | 'auto_incorrect' | 'start_date' | 'created_at' | 'updated_at' | 'target_completion_date' | 'max_visited_element' | 'num_responses' | 'available_points' | 'pass_mark' | 'rating' | 'feedback' | 'topic_id' | 'duration' | 'shared_by' | 'share_batch_ts' | 'canBeRestarted'>
    & { notificationMessage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicNotificationModel' }
      & Pick<PrivateSchemaTypes.TopicNotificationModel, 'message_code'>
    )>, quizResponses: Array<(
      { __typename?: 'ResponseModel' }
      & Pick<PrivateSchemaTypes.ResponseModel, 'freeQuizResponse' | 'is_correct' | 'topic_element_id'>
      & { optionResponses?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'SingleOptionResponse' }
        & Pick<PrivateSchemaTypes.SingleOptionResponse, 'value' | 'is_correct' | 'option_id'>
      )>> }
    )>, topicVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModel' }
      & TopicVersionFragment
    )> }
  ), author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'email' | 'profile_img_url'>
  ) }
);

export type TopicWithEnrolment_TopicModelAsMember_Fragment = (
  { __typename?: 'TopicModelAsMember' }
  & Pick<PrivateSchemaTypes.TopicModelAsMember, 'isWorkspaceAccessible' | 'id' | 'allow_comments' | 'workspace_id' | 'deleted_at' | 'currentTitle' | 'lastPublishedDate' | 'firstPublishedDate'>
  & { workspace: (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id' | 'name'>
  ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & CurrentTopicVersionFragment
  )>, enrolmentOrSelfEnrol: (
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'isCpdEntry' | 'id' | 'completion_date' | 'progress' | 'trackAccess' | 'attempt' | 'user_id' | 'topic_version_id' | 'auto_correct' | 'auto_incorrect' | 'start_date' | 'created_at' | 'updated_at' | 'target_completion_date' | 'max_visited_element' | 'num_responses' | 'available_points' | 'pass_mark' | 'rating' | 'feedback' | 'topic_id' | 'duration' | 'shared_by' | 'share_batch_ts' | 'canBeRestarted'>
    & { notificationMessage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicNotificationModel' }
      & Pick<PrivateSchemaTypes.TopicNotificationModel, 'message_code'>
    )>, quizResponses: Array<(
      { __typename?: 'ResponseModel' }
      & Pick<PrivateSchemaTypes.ResponseModel, 'freeQuizResponse' | 'is_correct' | 'topic_element_id'>
      & { optionResponses?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'SingleOptionResponse' }
        & Pick<PrivateSchemaTypes.SingleOptionResponse, 'value' | 'is_correct' | 'option_id'>
      )>> }
    )>, topicVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModel' }
      & TopicVersionFragment
    )> }
  ), author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'email' | 'profile_img_url'>
  ) }
);

export type TopicWithEnrolmentFragment = TopicWithEnrolment_TopicModelAsEditor_Fragment | TopicWithEnrolment_TopicModelAsMember_Fragment;

export type CurrentTopicVersionFragment = (
  { __typename?: 'TopicVersionModel' }
  & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'allow_retry' | 'readDurationMins' | 'version' | 'max_attempts' | 'topic_type'>
);

export type TopicVersionFragment = (
  { __typename?: 'TopicVersionModel' }
  & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'created_at' | 'title' | 'summary' | 'pass_mark' | 'status' | 'minor_version' | 'allow_retry' | 'topic_type' | 'readDurationMins' | 'number_quizzes' | 'isCurrent' | 'version' | 'max_attempts'>
  & { publishedElements?: PrivateSchemaTypes.Maybe<Array<(
    { __typename?: 'TopicElementModel' }
    & Pick<PrivateSchemaTypes.TopicElementModel, 'id' | 'data' | 'duration' | 'type' | 'updated_at'>
    & { documents: Array<(
      { __typename?: 'VideoDocument' }
      & Pick<PrivateSchemaTypes.VideoDocument, 'id' | 'status' | 'fileUrl' | 'cdnUrl' | 'mimeType'>
    )>, quizOptions: Array<(
      { __typename?: 'QuizOptionModel' }
      & Pick<PrivateSchemaTypes.QuizOptionModel, 'id' | 'content' | 'order' | 'feedback'>
    )> }
  )>> }
);

export type PathwayNextTopicFragment = (
  { __typename?: 'TopicModelAsMember' }
  & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  & { author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
  ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'summary' | 'readDurationMins'>
  )>, coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
  )>, coverImageVariants: Array<(
    { __typename?: 'ImageVariantModel' }
    & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'file_url' | 'size_key'>
  )> }
);

export const TopicVersionFragmentDoc = gql`
    fragment topicVersion on TopicVersionModel {
  id
  created_at
  title
  summary
  pass_mark
  status
  minor_version
  allow_retry
  topic_type
  readDurationMins
  number_quizzes
  isCurrent
  version
  max_attempts
  publishedElements {
    id
    data
    duration
    type
    updated_at
    documents {
      id
      status
      fileUrl
      cdnUrl
      mimeType
    }
    quizOptions {
      id
      content
      order
      feedback
    }
  }
}
    `;
export const TopicWithVersionFragmentDoc = gql`
    fragment TopicWithVersion on ITopicModel {
  id
  allow_comments
  workspace_id
  deleted_at
  currentTitle
  currentTopicVersion {
    id
    allow_retry
    readDurationMins
    version
    max_attempts
    topic_type
  }
  lastCompletedEnrolment {
    id
    isCpdEntry
  }
  ... on TopicModelAsEditor {
    topicVersions(filters: [{name: version, value: $topicVersion}]) {
      ...topicVersion
    }
    workspaceAsEditor: workspace {
      id
      name
    }
  }
  ... on TopicModelAsMember {
    isWorkspaceAccessible
    workspace {
      id
      name
    }
  }
  lastPublishedDate
  firstPublishedDate
  author {
    id
    display_name
    email
    profile_img_url
  }
}
    ${TopicVersionFragmentDoc}`;
export const CurrentTopicVersionFragmentDoc = gql`
    fragment currentTopicVersion on TopicVersionModel {
  id
  allow_retry
  readDurationMins
  version
  max_attempts
  topic_type
}
    `;
export const TopicWithEnrolmentFragmentDoc = gql`
    fragment TopicWithEnrolment on ITopicModel {
  id
  allow_comments
  workspace_id
  deleted_at
  ... on TopicModelAsMember {
    isWorkspaceAccessible
    workspace {
      id
      name
    }
  }
  ... on TopicModelAsEditor {
    workspaceAsEditor: workspace {
      id
      name
    }
  }
  currentTitle
  currentTopicVersion {
    ...currentTopicVersion
  }
  lastPublishedDate
  firstPublishedDate
  enrolmentOrSelfEnrol(restartEnrolment: $restartEnrolment) {
    isCpdEntry
    id
    completion_date
    progress
    notificationMessage {
      message_code
    }
    quizResponses {
      optionResponses {
        value
        is_correct
        option_id
      }
      freeQuizResponse
      is_correct
      topic_element_id
    }
    trackAccess
    topicVersion {
      ...topicVersion
    }
    attempt
    user_id
    topic_version_id
    auto_correct
    auto_incorrect
    progress
    start_date
    created_at
    updated_at
    completion_date
    target_completion_date
    max_visited_element
    num_responses
    available_points
    pass_mark
    completion_date
    rating
    feedback
    topic_id
    topic_version_id
    duration
    shared_by
    share_batch_ts
    canBeRestarted
  }
  author {
    id
    display_name
    email
    profile_img_url
  }
}
    ${CurrentTopicVersionFragmentDoc}
${TopicVersionFragmentDoc}`;
export const PathwayNextTopicFragmentDoc = gql`
    fragment pathwayNextTopic on TopicModelAsMember {
  id
  author {
    id
    display_name
  }
  currentTopicVersion {
    id
    title
    summary
    readDurationMins
  }
  coverImage {
    id
    cdnUrl
  }
  coverImageVariants {
    cdnUrl
    file_url
    size_key
  }
}
    `;
export const OpenTopicEnrolmentDocument = gql`
    query openTopicEnrolment($topicId: PositiveInt!, $restartEnrolment: Boolean) {
  topic(id: $topicId) {
    ...TopicWithEnrolment
  }
}
    ${TopicWithEnrolmentFragmentDoc}`;

/**
 * __useOpenTopicEnrolmentQuery__
 *
 * To run a query within a React component, call `useOpenTopicEnrolmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenTopicEnrolmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenTopicEnrolmentQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      restartEnrolment: // value for 'restartEnrolment'
 *   },
 * });
 */
export function useOpenTopicEnrolmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OpenTopicEnrolmentQuery, OpenTopicEnrolmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OpenTopicEnrolmentQuery, OpenTopicEnrolmentQueryVariables>(OpenTopicEnrolmentDocument, options);
      }
export function useOpenTopicEnrolmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpenTopicEnrolmentQuery, OpenTopicEnrolmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OpenTopicEnrolmentQuery, OpenTopicEnrolmentQueryVariables>(OpenTopicEnrolmentDocument, options);
        }
export type OpenTopicEnrolmentQueryHookResult = ReturnType<typeof useOpenTopicEnrolmentQuery>;
export type OpenTopicEnrolmentLazyQueryHookResult = ReturnType<typeof useOpenTopicEnrolmentLazyQuery>;
export type OpenTopicEnrolmentQueryResult = Apollo.QueryResult<OpenTopicEnrolmentQuery, OpenTopicEnrolmentQueryVariables>;
export const OpenTopicEnrolmentThroughPathwayDocument = gql`
    query openTopicEnrolmentThroughPathway($pathwayId: PositiveInt!, $topicId: PositiveInt!, $restartEnrolment: Boolean) {
  pathway(id: $pathwayId) {
    id
    enrolmentOrSelfEnrol {
      progress
    }
    title
    progress
    topic(id: $topicId) {
      ...TopicWithEnrolment
    }
    nextTopicAfter(topicId: $topicId) {
      ...pathwayNextTopic
    }
  }
}
    ${TopicWithEnrolmentFragmentDoc}
${PathwayNextTopicFragmentDoc}`;

/**
 * __useOpenTopicEnrolmentThroughPathwayQuery__
 *
 * To run a query within a React component, call `useOpenTopicEnrolmentThroughPathwayQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenTopicEnrolmentThroughPathwayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenTopicEnrolmentThroughPathwayQuery({
 *   variables: {
 *      pathwayId: // value for 'pathwayId'
 *      topicId: // value for 'topicId'
 *      restartEnrolment: // value for 'restartEnrolment'
 *   },
 * });
 */
export function useOpenTopicEnrolmentThroughPathwayQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OpenTopicEnrolmentThroughPathwayQuery, OpenTopicEnrolmentThroughPathwayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OpenTopicEnrolmentThroughPathwayQuery, OpenTopicEnrolmentThroughPathwayQueryVariables>(OpenTopicEnrolmentThroughPathwayDocument, options);
      }
export function useOpenTopicEnrolmentThroughPathwayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpenTopicEnrolmentThroughPathwayQuery, OpenTopicEnrolmentThroughPathwayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OpenTopicEnrolmentThroughPathwayQuery, OpenTopicEnrolmentThroughPathwayQueryVariables>(OpenTopicEnrolmentThroughPathwayDocument, options);
        }
export type OpenTopicEnrolmentThroughPathwayQueryHookResult = ReturnType<typeof useOpenTopicEnrolmentThroughPathwayQuery>;
export type OpenTopicEnrolmentThroughPathwayLazyQueryHookResult = ReturnType<typeof useOpenTopicEnrolmentThroughPathwayLazyQuery>;
export type OpenTopicEnrolmentThroughPathwayQueryResult = Apollo.QueryResult<OpenTopicEnrolmentThroughPathwayQuery, OpenTopicEnrolmentThroughPathwayQueryVariables>;
export const OpenTopicWithVersionDocument = gql`
    query openTopicWithVersion($topicId: PositiveInt!, $topicVersion: JSON!) {
  topic(id: $topicId) {
    ...TopicWithVersion
  }
}
    ${TopicWithVersionFragmentDoc}`;

/**
 * __useOpenTopicWithVersionQuery__
 *
 * To run a query within a React component, call `useOpenTopicWithVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenTopicWithVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenTopicWithVersionQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      topicVersion: // value for 'topicVersion'
 *   },
 * });
 */
export function useOpenTopicWithVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OpenTopicWithVersionQuery, OpenTopicWithVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OpenTopicWithVersionQuery, OpenTopicWithVersionQueryVariables>(OpenTopicWithVersionDocument, options);
      }
export function useOpenTopicWithVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpenTopicWithVersionQuery, OpenTopicWithVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OpenTopicWithVersionQuery, OpenTopicWithVersionQueryVariables>(OpenTopicWithVersionDocument, options);
        }
export type OpenTopicWithVersionQueryHookResult = ReturnType<typeof useOpenTopicWithVersionQuery>;
export type OpenTopicWithVersionLazyQueryHookResult = ReturnType<typeof useOpenTopicWithVersionLazyQuery>;
export type OpenTopicWithVersionQueryResult = Apollo.QueryResult<OpenTopicWithVersionQuery, OpenTopicWithVersionQueryVariables>;
export const TopicDraftVersionDocument = gql`
    query topicDraftVersion($topicId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      allow_comments
      workspace_id
      workspace {
        id
        role
        name
      }
      draftVersion {
        id
        created_at
        title
        summary
        pass_mark
        status
        minor_version
        allow_retry
        topic_type
        readDurationMins
        max_attempts
        number_quizzes
        elements {
          id
          data
          duration
          type
          updated_at
          documents {
            id
            status
            fileUrl
            cdnUrl
            mimeType
          }
          quizOptions {
            content
            id
            order
            feedback
            is_correct
          }
        }
      }
      author {
        id
        display_name
        email
        profile_img_url
      }
    }
  }
}
    `;

/**
 * __useTopicDraftVersionQuery__
 *
 * To run a query within a React component, call `useTopicDraftVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicDraftVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicDraftVersionQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useTopicDraftVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopicDraftVersionQuery, TopicDraftVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TopicDraftVersionQuery, TopicDraftVersionQueryVariables>(TopicDraftVersionDocument, options);
      }
export function useTopicDraftVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicDraftVersionQuery, TopicDraftVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TopicDraftVersionQuery, TopicDraftVersionQueryVariables>(TopicDraftVersionDocument, options);
        }
export type TopicDraftVersionQueryHookResult = ReturnType<typeof useTopicDraftVersionQuery>;
export type TopicDraftVersionLazyQueryHookResult = ReturnType<typeof useTopicDraftVersionLazyQuery>;
export type TopicDraftVersionQueryResult = Apollo.QueryResult<TopicDraftVersionQuery, TopicDraftVersionQueryVariables>;
export const UpdateEnrolmentProgressDocument = gql`
    mutation updateEnrolmentProgress($topicId: PositiveInt!, $elementId: PositiveInt!) {
  topic(id: $topicId) {
    id
    lastEnrolment {
      id
      updateProgress(elementId: $elementId) {
        id
        progress
        completion_date
        max_visited_element
      }
    }
  }
}
    `;
export type UpdateEnrolmentProgressMutationFn = Apollo.MutationFunction<UpdateEnrolmentProgressMutation, UpdateEnrolmentProgressMutationVariables>;

/**
 * __useUpdateEnrolmentProgressMutation__
 *
 * To run a mutation, you first call `useUpdateEnrolmentProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnrolmentProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnrolmentProgressMutation, { data, loading, error }] = useUpdateEnrolmentProgressMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *   },
 * });
 */
export function useUpdateEnrolmentProgressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEnrolmentProgressMutation, UpdateEnrolmentProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEnrolmentProgressMutation, UpdateEnrolmentProgressMutationVariables>(UpdateEnrolmentProgressDocument, options);
      }
export type UpdateEnrolmentProgressMutationHookResult = ReturnType<typeof useUpdateEnrolmentProgressMutation>;
export type UpdateEnrolmentProgressMutationResult = Apollo.MutationResult<UpdateEnrolmentProgressMutation>;
export type UpdateEnrolmentProgressMutationOptions = Apollo.BaseMutationOptions<UpdateEnrolmentProgressMutation, UpdateEnrolmentProgressMutationVariables>;
export const OpenedFromCampaignShareEmailDocument = gql`
    mutation openedFromCampaignShareEmail($id: PositiveInt!, $scheduledActionId: PositiveInt!) {
  topic(id: $id) {
    id
    openedFromCampaignShareEmail(scheduledCampaignActionId: $scheduledActionId)
  }
}
    `;
export type OpenedFromCampaignShareEmailMutationFn = Apollo.MutationFunction<OpenedFromCampaignShareEmailMutation, OpenedFromCampaignShareEmailMutationVariables>;

/**
 * __useOpenedFromCampaignShareEmailMutation__
 *
 * To run a mutation, you first call `useOpenedFromCampaignShareEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenedFromCampaignShareEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openedFromCampaignShareEmailMutation, { data, loading, error }] = useOpenedFromCampaignShareEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheduledActionId: // value for 'scheduledActionId'
 *   },
 * });
 */
export function useOpenedFromCampaignShareEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenedFromCampaignShareEmailMutation, OpenedFromCampaignShareEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OpenedFromCampaignShareEmailMutation, OpenedFromCampaignShareEmailMutationVariables>(OpenedFromCampaignShareEmailDocument, options);
      }
export type OpenedFromCampaignShareEmailMutationHookResult = ReturnType<typeof useOpenedFromCampaignShareEmailMutation>;
export type OpenedFromCampaignShareEmailMutationResult = Apollo.MutationResult<OpenedFromCampaignShareEmailMutation>;
export type OpenedFromCampaignShareEmailMutationOptions = Apollo.BaseMutationOptions<OpenedFromCampaignShareEmailMutation, OpenedFromCampaignShareEmailMutationVariables>;
export const LastEnrolmentForUserDocument = gql`
    query lastEnrolmentForUser($topicId: PositiveInt!) {
  topic(id: $topicId) {
    id
    lastEnrolment {
      id
      progress
      auto_correct
      completion_date
      max_visited_element
      isCpdEntry
    }
  }
}
    `;

/**
 * __useLastEnrolmentForUserQuery__
 *
 * To run a query within a React component, call `useLastEnrolmentForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastEnrolmentForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastEnrolmentForUserQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useLastEnrolmentForUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LastEnrolmentForUserQuery, LastEnrolmentForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LastEnrolmentForUserQuery, LastEnrolmentForUserQueryVariables>(LastEnrolmentForUserDocument, options);
      }
export function useLastEnrolmentForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LastEnrolmentForUserQuery, LastEnrolmentForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LastEnrolmentForUserQuery, LastEnrolmentForUserQueryVariables>(LastEnrolmentForUserDocument, options);
        }
export type LastEnrolmentForUserQueryHookResult = ReturnType<typeof useLastEnrolmentForUserQuery>;
export type LastEnrolmentForUserLazyQueryHookResult = ReturnType<typeof useLastEnrolmentForUserLazyQuery>;
export type LastEnrolmentForUserQueryResult = Apollo.QueryResult<LastEnrolmentForUserQuery, LastEnrolmentForUserQueryVariables>;
export const AddFreeQuizResponseDocument = gql`
    mutation addFreeQuizResponse($topicId: PositiveInt!, $elementId: PositiveInt!, $response: String!) {
  topic(id: $topicId) {
    id
    lastEnrolment {
      id
      completion_date
      addFreeQuizResponse(elementId: $elementId, response: $response) {
        is_correct
        freeQuizResponse
        optionResponses {
          value
          is_correct
          option_id
        }
        topic_element_id
      }
    }
  }
}
    `;
export type AddFreeQuizResponseMutationFn = Apollo.MutationFunction<AddFreeQuizResponseMutation, AddFreeQuizResponseMutationVariables>;

/**
 * __useAddFreeQuizResponseMutation__
 *
 * To run a mutation, you first call `useAddFreeQuizResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFreeQuizResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFreeQuizResponseMutation, { data, loading, error }] = useAddFreeQuizResponseMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      response: // value for 'response'
 *   },
 * });
 */
export function useAddFreeQuizResponseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFreeQuizResponseMutation, AddFreeQuizResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFreeQuizResponseMutation, AddFreeQuizResponseMutationVariables>(AddFreeQuizResponseDocument, options);
      }
export type AddFreeQuizResponseMutationHookResult = ReturnType<typeof useAddFreeQuizResponseMutation>;
export type AddFreeQuizResponseMutationResult = Apollo.MutationResult<AddFreeQuizResponseMutation>;
export type AddFreeQuizResponseMutationOptions = Apollo.BaseMutationOptions<AddFreeQuizResponseMutation, AddFreeQuizResponseMutationVariables>;
export const AddQuizResponseDocument = gql`
    mutation addQuizResponse($topicId: PositiveInt!, $elementId: PositiveInt!, $optionResponses: [SingleOptionResponseInput!]!) {
  topic(id: $topicId) {
    id
    lastEnrolment {
      id
      completion_date
      addQuizResponse(elementId: $elementId, optionResponses: $optionResponses) {
        is_correct
        optionResponses {
          value
          is_correct
          option_id
        }
        topic_element_id
      }
    }
  }
}
    `;
export type AddQuizResponseMutationFn = Apollo.MutationFunction<AddQuizResponseMutation, AddQuizResponseMutationVariables>;

/**
 * __useAddQuizResponseMutation__
 *
 * To run a mutation, you first call `useAddQuizResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuizResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuizResponseMutation, { data, loading, error }] = useAddQuizResponseMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      optionResponses: // value for 'optionResponses'
 *   },
 * });
 */
export function useAddQuizResponseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddQuizResponseMutation, AddQuizResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddQuizResponseMutation, AddQuizResponseMutationVariables>(AddQuizResponseDocument, options);
      }
export type AddQuizResponseMutationHookResult = ReturnType<typeof useAddQuizResponseMutation>;
export type AddQuizResponseMutationResult = Apollo.MutationResult<AddQuizResponseMutation>;
export type AddQuizResponseMutationOptions = Apollo.BaseMutationOptions<AddQuizResponseMutation, AddQuizResponseMutationVariables>;